export const setSingleWdataTal = (payload) => {
    return {
        type: "SET_SINGLE_WDATA_TAL",
        payload
    }
};
export const setSingleWdataBerge = (payload) => {
    return {
        type: "SET_SINGLE_WDATA_BERGE",
        payload
    }
};
export const setMultiWdataTal = (payload) => {
    return {
        type: "SET_MULTI_WDATA_TAL",
        payload
    }
};
export const setMultiWdataBerge = (payload) => {
    return {
        type: "SET_MULTI_WDATA_BERGE",
        payload
    }
};
export const setActiveTab = (payload) => {
    return {
        type: "SET_ACTIVE_TAB",
        payload
    }
};

